// Global configuration for allowed document types
// This can be easily extended in the future to add new document types

export const ALLOWED_DOCUMENT_TYPES = {
  pdf: {
    extensions: ['pdf'],
    mimeTypes: ['application/pdf'],
    label: 'PDF'
  },
  word: {
    extensions: ['doc', 'docx'],
    mimeTypes: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    label: 'Word'
  },
  excel: {
    extensions: ['xls', 'xlsx'],
    mimeTypes: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    label: 'Excel'
  },
  image: {
    extensions: ['png', 'jpeg', 'jpg', 'gif'],
    mimeTypes: ['image/png', 'image/jpeg', 'image/gif'],
    label: 'Image'
  },
  notepad: {
    extensions: ['txt'],
    mimeTypes: ['text/plain'],
    label: 'Notepad'
  }
};

// Get all allowed extensions as a flat array
export const getAllowedExtensions = () => {
  return Object.values(ALLOWED_DOCUMENT_TYPES).flatMap(type => type.extensions);
};

// Get all allowed MIME types as a flat array
export const getAllowedMimeTypes = () => {
  return Object.values(ALLOWED_DOCUMENT_TYPES).flatMap(type => type.mimeTypes);
};

// Validate if a file type is allowed
export const isFileTypeAllowed = (fileName) => {
  if (!fileName) return false;
  const extension = fileName.split('.').pop()?.toLowerCase();
  return getAllowedExtensions().includes(extension);
};

// Get file type category from file name
export const getFileTypeCategory = (fileName) => {
  if (!fileName) return null;
  const extension = fileName.split('.').pop()?.toLowerCase();
  
  for (const [category, config] of Object.entries(ALLOWED_DOCUMENT_TYPES)) {
    if (config.extensions.includes(extension)) {
      return category;
    }
  }
  
  return null;
};

// Get accept attribute for file input
export const getFileInputAccept = () => {
  return getAllowedExtensions().map(ext => `.${ext}`).join(',');
};

